import React from "react";
import {useDispatch, useSelector} from "react-redux";
import styles from "./ActiveFilter.module.scss";
import {HIDE_MENU} from "../../Store/Actions/ActionTypes";
import {
    DEACTIVATE_DEPENDENT_FACETS,
    DEACTIVATE_FACET,
    DEACTIVATE_FACET_MULTI,
    REMOVE_FROM_AVAILABLE_GROUPS,
    UNSET_SEARCH_VALUE
} from "../../Store/Actions/ActionTypes";
import getActiveMainFacetID from "../../Utils/getActiveMainFacetID";
import {
    deactivateDependentFacets,
    getMiddlefacetGroups,
    updateMainFacetsCount
} from "../../Store/Actions/NewFilterActions";

const ActiveFilter = (props) => {
    const {value, facetName, isMultivalue, isComposite} = props;
    const newFilterState = useSelector(state => state.newFilterReducer);
    const activeFilters = newFilterState.activeFilters;
    const availableGroups = newFilterState.availableGroups;
    const facets = newFilterState.facets;
    const dispatch = useDispatch();
    const activeMainFacetID = getActiveMainFacetID(newFilterState);
    const activeMainFacet = facets[activeMainFacetID];
    const handleClick = () => {

        // Check if it was the search value that is being removed.
        if (facetName === 'query_value' || isComposite) {
            dispatch({type: UNSET_SEARCH_VALUE});
            dispatch(updateMainFacetsCount(""));
            return;
        }

        const payload = {
            facetName: facetName
        };
        if (!isMultivalue) {
            dispatch({type: DEACTIVATE_FACET, payload: payload});
        }
        else {
            payload.value = value;
            dispatch({type: DEACTIVATE_FACET_MULTI, payload: payload});
        }


        // If this is a hovedfasett, then all possible child facets need to be removed.
        // 1. middlefacets
        // 2. general facets of this hovedfasett
        // 3. facets that might be coming from the middlefacets
        if (activeMainFacetID && facetName === 'hovedfasett') {
            let facetsToUnset = ['hovedfasett'];
            // 1. middlefacets
            if (activeMainFacet.middlefacets !== undefined) {
                const middlefacets = activeMainFacet.middlefacets;
                for (const [, middlefacet] of Object.entries(middlefacets)) {
                    facetsToUnset.push(middlefacet.facetName);
                }

            }
            // 2. general facets of this hovedfasett
            // 3. facets that might be coming from the middle facet
            for (const [, group] of Object.entries(availableGroups)) {
                const myFacetName = group.facetName;
                if (facetsToUnset.indexOf(myFacetName) === -1) {
                    facetsToUnset.push(myFacetName);
                }
            }
            const ftuPayload = {
                "activeMainFacetID": activeMainFacetID,
                "facetsToUnset": facetsToUnset
            };
            dispatch({type: DEACTIVATE_DEPENDENT_FACETS, payload: ftuPayload});
            
            dispatch({type:HIDE_MENU});
            return;
        }

        // If this is a middlefacet, then its child facets need to be removed, and also its groups.
        if (activeMainFacetID && activeMainFacet.middlefacets !== undefined) {
            dispatch(deactivateDependentFacets(activeMainFacet, facetName, activeFilters, activeMainFacetID));

            const middlefacetGroups = getMiddlefacetGroups(facetName, value);
            if (middlefacetGroups) {
                const groupsPayload = {
                    groups: Object.keys(middlefacetGroups)
                };
                dispatch({type: REMOVE_FROM_AVAILABLE_GROUPS, payload: groupsPayload});
            }
            return;
        }
    };

    return (
        <button
            className={styles.wrapper}
            onClick={handleClick}
        >
            {value}
            <span>×</span>
        </button>
    )
};

export default ActiveFilter;
